import { match } from 'ts-pattern';

import { BasePayloadMapper } from '@ps/utils';
import {
  completesToClick,
  SupplierAllocationsEditableContext,
  SupplierAllocationsParams,
  SupplierAllocationsUpdateContext,
} from '@ps/survey-utils';

import { SupplierAllocationsParamsDto } from '../dtos/supplier.dto';

export class SupplierAllocationsParamsPayloadMapper extends BasePayloadMapper<
  SupplierAllocationsParams,
  SupplierAllocationsParamsDto
> {
  public toPayload(
    params: SupplierAllocationsParams,
  ): SupplierAllocationsParamsDto {
    return match(params)
      .with({ scope: 'view' }, () => this._viewPayload())
      .with({ scope: 'editable' }, ({ context }) =>
        this._editablePayload(context),
      )
      .with({ scope: 'update' }, ({ context }) => this._updatePayload(context))
      .exhaustive();
  }

  private _viewPayload(): SupplierAllocationsParamsDto {
    return { mode: 'view', UI: 1 };
  }

  private _editablePayload(
    context: SupplierAllocationsEditableContext,
  ): SupplierAllocationsParamsDto {
    return {
      mode: 'editable',
      stats: 1,
      LOI: context.loi,
      IR: context.ir,
      LNG: context.languageCode,
      fieldTime: context.fieldTime,
      goal: context.goal,
      click_balancing: context.clickBalancing,
      ...(context.clickBalancing
        ? { estimated_clicks: completesToClick(context.goal, context.ir) }
        : {}),
      epc: 1,
      UI: 1,
    };
  }

  private _updatePayload(
    context: SupplierAllocationsUpdateContext,
  ): SupplierAllocationsParamsDto {
    return {
      mode: 'editable',
      stats: 1,
      LOI: context.loi,
      IR: context.ir,
      LNG: context.languageCode,
      fieldTime: context.fieldTime,
      click_balancing: context.clickBalancing,
      ...(context.clickBalancing
        ? { estimated_clicks: completesToClick(context.goal, context.ir) }
        : {}),
      epc: 1,
      UI: 1,
      manual_override: context.manualOverrideEnabled,
      price_override: context.globalOverrideValue.unwrapOr(''),
      default_pure_price_override: context.defaultPurePriceOverride,
      is_pure_price_rate_card_enable: context.isPurePriceRateCardEnable,
      supplier_default_allocation: context.supplierDefaultAllocation,
      // TODO: hardcoded until supplier blends are wired in (separate ticket).
      blend_id: 0,
      ...(context.pauseThresholdValue.isSome()
        ? { survey_pause_threshold: context.pauseThresholdValue.unwrap() }
        : {}),
    };
  }
}
